import HelpRequest from "../../../model/help/HelpRequest";
import {OnFailure, OnSuccess} from "../actionHelpers";
import {Dispatch} from "react-redux";
import {api} from "../../../api/api";

/**
 * Send help request.
 * @param {HelpRequest} data help request data
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function sendHelpRequest(data: HelpRequest, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function() {
		api.instance.helpApi.createHelpRequest(data).then(onSuccess).catch(onFailure);
	}
}